import { Outlet, createFileRoute } from "@tanstack/react-router";

import { PageTemplate } from "@shared/ui/templates/page-template";
import { HelpBox } from "@widgets/profile-avatar/ui/help-box.tsx";

export const Route = createFileRoute("/_public")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PageTemplate profileSlot={<HelpBox email="segunadebayo@mail.com" />}>
      <Outlet />
    </PageTemplate>
  );
}
